import { render, staticRenderFns } from "./MeusCartoes.vue?vue&type=template&id=9854f1b6&scoped=true"
import script from "./MeusCartoes.vue?vue&type=script&lang=js"
export * from "./MeusCartoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9854f1b6",
  null
  
)

export default component.exports